import { checksumAddress, isAddress } from "viem";

const formatAddress = (address: string, small: boolean): string => {
  if (!isAddress(address)) throw new Error("Invalid address");
  if (small) {
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  }
  return checksumAddress(address);
};

export { formatAddress };
